
const PageFive = () => {
  return (
    <>
      <p className="text-xl font-bold text-foreground">BroScore is earned:</p>
      <ul className="list-disc list-inside text-xl pl-6 space-y-2 text-foreground">
        <li>Daily Rituals → +25 BroScore</li>
        <li>Wager Wins → +100 BroScore</li>
        <li>Memes, Posts, Proofs → +5 BroScore</li>
        <li>Voting on Proofs → +2 BroScore</li>
        <li>Donations → bonus-matched BroScore</li>
      </ul>
      
      <p className="text-xl font-bold mt-4 text-foreground">BroScore is burned:</p>
      <ul className="list-disc list-inside text-xl pl-6 space-y-2 text-foreground">
        <li>Reroll BroCode → 500 BroScore</li>
        <li>Ascend to Brometheus → 5,000 BroScore or 100k TOP1</li>
      </ul>
      
      <p className="text-xl mt-4 text-foreground">Weekly TOP1 airdrops go to top BroScore Bros.</p>
      
      <p className="text-xl mt-6 font-bold text-foreground">THE FUTURE OF BRODOM</p>
      
      <p className="text-xl text-foreground">We're not building an app.</p>
      <p className="text-xl text-foreground">We're building an economy of challenge, proof, and agency.</p>
      
      <p className="text-xl mt-4 text-foreground">Coming Soon:</p>
      <ul className="list-disc list-inside text-xl pl-6 space-y-2 text-foreground">
        <li>Agentic Swarms — Bros deploy on-chain agents to earn, build, act</li>
        <li>A Descrow — A decentralized escrow platform for challenge payouts</li>
        <li>Bro Agents — Auto-launch tokens, run missions, forge rituals</li>
        <li>Ritual IRL — Real-world gatherings, rituals, proof-of-brotherhood</li>
      </ul>
    </>
  );
};

export default PageFive;
